/* eslint-disable import/prefer-default-export */
import loadable from '@loadable/component'
import React from 'react'
import LoadingPage from '@components/LoadingPage'

const loading = <LoadingPage />

export const Dashboard = loadable(() => import('./Admin/Dashboard'), {
  fallback: loading,
})

export const Account = loadable(() => import('./Admin/Account'), {
  fallback: loading,
})

export const ChangePassword = loadable(() => import('./Admin/ChangePassword'), {
  fallback: loading,
})

export const ProductManagement = loadable(() => import('./Admin/ProductManagement'), {
  fallback: loading,
})

export const ProductAndStockDetail = loadable(() => import('./Admin/ProductManagement/ProductAndStockDetail'), {
  fallback: loading,
})

export const OrderManagement = loadable(() => import('./Admin/OrderManagement'), {
  fallback: loading,
})

export const OrderManagementDetail = loadable(() => import('./Admin/OrderManagement/SalesOrderDetails'), {
  fallback: loading,
})

export const StockManagement = loadable(() => import('./Admin/StockManagement'), {
  fallback: loading,
})

export const PurchaseOrder = loadable(() => import('./Admin/PurchaseOrder'), {
  fallback: loading,
})

export const Customer = loadable(() => import('./Admin/Customer'), {
  fallback: loading,
})

export const DetailCustomer = loadable(() => import('./Admin/Customer/DetailCustomer'), {
  fallback: loading,
})

export const PurchaseOrderItem = loadable(() => import('./Admin/OrderItems/PurchaseOrder'), {
  fallback: loading,
})

export const PurchaseOrderItemDetail = loadable(() => import('./Admin/OrderItems/PurchaseOrder/PurchaseOrderDetails'), {
  fallback: loading,
})

export const SalesOrderItem = loadable(() => import('./Admin/OrderItems/SalesOrder'), {
  fallback: loading,
})

export const SalesOrderItemDetail = loadable(() => import('./Admin/OrderItems/SalesOrder/SalesOrderDetails'), {
  fallback: loading,
})

export const ProductInformation = loadable(() => import('./Admin/ProductInformation'), {
  fallback: loading,
})

export const ProductInformationDetail = loadable(() => import('./Admin/ProductInformation/ProductInfoDetail'), {
  fallback: loading,
})

export const BankAccount = loadable(() => import('./Admin/BankAccount'), {
  fallback: loading,
})

export const SetupCourier = loadable(() => import('./Admin/SetupCourier'), {
  fallback: loading,
})

export const Notifications = loadable(() => import('./Admin/Notifications'), {
  fallback: loading,
})

export const Members = loadable(() => import('./Admin/Members'), {
  fallback: loading,
})

export const MemberDetails = loadable(() => import('./Admin/Members/DetailMember'), {
  fallback: loading,
})

export const TopUp = loadable(() => import('./Admin/TopUp'), {
  fallback: loading,
})

export const BalanceLog = loadable(() => import('./Admin/BalanceLog'), {
  fallback: loading,
})

export const CommissionReport = loadable(() => import('./Admin/CommissionReport'), {
  fallback: loading,
})

export const PointReward = loadable(() => import('./Admin/PointReward'), {
  fallback: loading,
})

export const MyReward = loadable(() => import('./Admin/MyReward'), {
  fallback: loading,
})

export const MemberPurchaseReports = loadable(() => import('./Admin/MemberPurchaseReports'), {
  fallback: loading,
})

export const MemberSalesReports = loadable(() => import('./Admin/MemberSalesReports'), {
  fallback: loading,
})
export const PreOrder = loadable(() => import('./Admin/PreOrder'), {
  fallback: loading,
})

export const DetailPurchaseReports = loadable(() => import('./Admin/MemberPurchaseReports/DetailPurchaseReports'), {
  fallback: loading,
})
export const DetailSalesReports = loadable(() => import('./Admin/MemberSalesReports/DetailSalesReports'), {
  fallback: loading,
})

export const PurchasePreOrder = loadable(() => import('./Admin/PreOrder/PurchasePreOrder/PurchasePreOrder'), {
  fallback: loading,
})
export const DetailPreOrder = loadable(() => import('./Admin/PreOrder/DetailPreOrder/DetailPreOrder'), {
  fallback: loading,
})

export const OrderChannel = loadable(() => import('./Admin/OrderChannel'), {
  fallback: loading,
})

export const MemberVisit = loadable(() => import('./Admin/Members/MemberVisit'), {
  fallback: loading,
})
